const insight1 = '/insight1.png'
const insight2 = '/insight2.png'
const insight3 = '/insight3.png'

export const insights = [
    {
      role: "Engineering Leaders",
      icon: insight1,
      points: [
        "Improve release predictability with data-driven insights.",
        "Drive efficiency through seamless automation and AI-optimized strategies.",
        "Reduce costs by streamlining test cycles and defect triage."
      ]
    },
    {
      role: "Heads of Testing and Test Managers",
      icon: insight2,
      points: [
        "Achieve better test coverage with automated planning and execution matrix design.",
        "Gain end-to-end traceability with integrated dashboards and metrics.",
        "Deliver faster defect resolution with auto-association and actionable insights."
      ]
    },
    {
      role: "Testers",
      icon: insight3,
      points: [
        "Eliminate repetitive tasks with AI-driven recommendations.",
        "Focus on testing by automating execution and real-time updates.",
        "Quickly identify and resolve failures with auto-linked defect logs."
      ]
    }
  ];
  